/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCreateOrReactivateWizerRequest
 */
export interface ControlCreateOrReactivateWizerRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlCreateOrReactivateWizerRequest
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCreateOrReactivateWizerRequest
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCreateOrReactivateWizerRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCreateOrReactivateWizerRequest
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCreateOrReactivateWizerRequest
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCreateOrReactivateWizerRequest
     */
    company_name: string;
}

/**
 * Check if a given object implements the ControlCreateOrReactivateWizerRequest interface.
 */
export function instanceOfControlCreateOrReactivateWizerRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;
    isInstance = isInstance && "company_name" in value;

    return isInstance;
}

export function ControlCreateOrReactivateWizerRequestFromJSON(json: any): ControlCreateOrReactivateWizerRequest {
    return ControlCreateOrReactivateWizerRequestFromJSONTyped(json, false);
}

export function ControlCreateOrReactivateWizerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCreateOrReactivateWizerRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'client_id': json['client_id'],
        'user_id': json['user_id'],
        'email': json['email'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'company_name': json['company_name'],
    };
}

export function ControlCreateOrReactivateWizerRequestToJSON(value?: ControlCreateOrReactivateWizerRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.client_id,
        'user_id': value.user_id,
        'email': value.email,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'company_name': value.company_name,
    };
}

